import React from 'react';
import { NavLink  } from "react-router-dom";

import './HeaderSection.scss';
import Logo from './logo.png';

class HeaderSection extends React.Component {

    state = {
        isActive: false
    }

    render() {
        const {isActive} = this.state;

        return (
            <header className={isActive ? 'active' : ''}>
                <div className="burger-icon" onClick={
                    () => {this.setState({isActive: !isActive})}
                }>
                    <img alt="" src="./assets/burger_icon.png"/>
                </div>
                <div className="container">
                    <NavLink to="/">
                        <img alt="logo" src={Logo} />
                    </NavLink>
                    <nav>
                        <ul>
                            <li><NavLink exact to="/" activeClassName="active">o nas</NavLink ></li>
                            <li><NavLink  to="/poligrafia" activeClassName="active">poligrafia</NavLink ></li>
                            <li><NavLink  to="/studio" activeClassName="active">studio graficzne</NavLink ></li>
                            <li><NavLink  to="/realizacje" activeClassName="active">realizacje</NavLink ></li>
                            <li><NavLink  to="/faq" activeClassName="active">FAQ</NavLink ></li>
                            <li><a href="/#contact-form">kontakt</a></li>
                        </ul>
                    </nav>
                </div>
            </header>
        );
    }
};

export default HeaderSection;